// Decline reason types and options for custom quote requests

import { mixed, object, string } from "yup";
import { LeadAssignmentStatus } from "types/declarations/enums.ts";

// Form data interface
export interface SubmitLeadFormData {
	leadStatus?: string;
	followUpDate?: Date | string | null;
	assignedToUserId?: string | null;
	orderNumber?: string;
	notes?: string;
	declineReason?: string;
}

// Form validation schema
export const submitLeadFormSchema = object({
	leadStatus: string(),
	orderNumber: string().when("leadStatus", {
		is: LeadAssignmentStatus.Sold,
		then: (schema) => schema.required("Order number is required when status is Sold"),
		otherwise: (schema) => schema.optional()
	}),
	followUpDate: mixed<Date | string>()
		.nullable()
		.when("leadStatus", {
			is: LeadAssignmentStatus.FollowUp,
			then: (schema) => schema.required("Follow up date is required when status is Follow Up"),
			otherwise: (schema) => schema.nullable().optional()
		}),
	assignedToUserId: string().nullable(),
	notes: string().max(1000, "Message cannot exceed 1000 characters"),
	declineReason: string()
});
